/**
 * Date and time for sent referrals and their receipts, Danish format in
 * Europe/Copenhagen, e.g. "15.10.2026 kl. 14:32" (MedCom CTL-Modtagelse
 * 3.10 / 3.14: send time and receipt time shown as two separate facts).
 */
const FORMAT = new Intl.DateTimeFormat('da-DK', {
  timeZone: 'Europe/Copenhagen',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

export function formatReferralDateTime(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    FORMAT.formatToParts(date).find((p) => p.type === type)?.value ?? '';
  return `${part('day')}.${part('month')}.${part('year')} kl. ${part('hour')}:${part('minute')}`;
}

/** Date only, Danish, Europe/Copenhagen — referral list and detail received_at. */
export function formatReferralDate(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    FORMAT.formatToParts(date).find((p) => p.type === type)?.value ?? '';
  return `${part('day')}.${part('month')}.${part('year')}`;
}

/** communicate-ctl sync-referrals `receiptTimes` → referral id → ISO time. */
export function receiptTimesById(
  times: readonly { referralId: string; receivedAt: string | null }[] | undefined,
): Record<string, string> {
  const byId: Record<string, string> = {};
  for (const time of times ?? []) {
    if (time.referralId && time.receivedAt) byId[time.referralId] = time.receivedAt;
  }
  return byId;
}
